"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableHeaderSettingsBehavior = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_pop_over_behavior_1 = require("../../../atoms/bc-pop-over/bc-pop-over-behavior");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var bc_modal_behavior_1 = require("../../../molecules/bc-modal/bc-modal-behavior");
var bc_data_table_header_settings_modal_1 = require("./bc-data-table-header-settings-modal");
var bc_tooltip_behavior_1 = require("../../../molecules/bc-tooltip/bc-tooltip-behavior");
var BcDataTableHeaderSettingsBehavior = (function () {
    function BcDataTableHeaderSettingsBehavior(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.popOverId = 'pop-over-' + this._generateRandomIdNumber();
        this.bcPopOverBehavior = new bc_pop_over_behavior_1.BcPopOverBehavior();
    }
    BcDataTableHeaderSettingsBehavior.prototype.init = function (headerDiv) {
        var divHeaderSettings = headerDiv.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SETTINGS_CLASS)[0];
        this._setHeaderSettings(divHeaderSettings);
        this._initComponentsInHeaderSettings();
        this._createModal();
        this._initTooltipSettings();
    };
    BcDataTableHeaderSettingsBehavior.prototype._generateRandomIdNumber = function () {
        return window.crypto.getRandomValues(new Uint32Array(1))[0];
    };
    BcDataTableHeaderSettingsBehavior.prototype._setHeaderSettings = function (divHeaderSettings) {
        var htmlPopOverSection = this._createHtmlPopOverSections(this.popOverId);
        document.body.prepend(htmlPopOverSection);
        var htmlPopOverIcon = this._createHtmlPopOverIcon(this.popOverId);
        divHeaderSettings.appendChild(htmlPopOverIcon);
        return divHeaderSettings;
    };
    BcDataTableHeaderSettingsBehavior.prototype._initComponentsInHeaderSettings = function () {
        var headerSettingsPopOver = document.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS, "#").concat(this.popOverId));
        this.bcPopOverBehavior.setId(headerSettingsPopOver.id);
        this.bcPopOverBehavior.setUp();
    };
    BcDataTableHeaderSettingsBehavior.prototype._initTooltipSettings = function () {
        var iconButton = document.getElementById(this.tooltipId);
        var bcTooltipBehavior = new bc_tooltip_behavior_1.BcTooltipBehavior();
        bcTooltipBehavior.setElement(iconButton);
        bcTooltipBehavior.setUp();
    };
    BcDataTableHeaderSettingsBehavior.prototype._createHtmlPopOverSections = function (popOverId) {
        var popOverSectionElement = this._createSectionElement(popOverId);
        var innerSectionElement = this._createInnerSectionElement();
        var innerSectionContent = this._createSectionContent();
        var innerSectionClose = this._createSectionClosePopOver();
        innerSectionElement.appendChild(innerSectionClose);
        innerSectionElement.appendChild(innerSectionContent);
        popOverSectionElement.appendChild(innerSectionElement);
        return popOverSectionElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype._createSectionClosePopOver = function () {
        var iconButton = this._createIconButton(common_constants_1.BcCommonConstants.ICON_ERROR, common_constants_1.BcCommonConstants.SMALL);
        this.listenerButtonClosePopOver(iconButton);
        iconButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, this._setAccesibilityButtonClose.bind(this));
        var divElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CONTENT_CLOSE_CLASS, "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-").concat(common_constants_1.BcCommonConstants.FLEX), 'bc-justify-content-end', 'bc-mt-1', 'bc-me-1');
        divElement.appendChild(iconButton);
        return divElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype._setAccesibilityButtonClose = function (event) {
        var _this = this;
        if (event.keyCode === bc_data_table_constants_1.BcDataTableConstansts.KEY_ENTER || event.keyCode === bc_data_table_constants_1.BcDataTableConstansts.KEY_SPACE) {
            setTimeout(function () {
                var headerTable = document.querySelector("#".concat(_this.bcDataTableConfig.id)).parentElement;
                var buttonSettings = headerTable.querySelector(".".concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_CLASS));
                if (buttonSettings.classList.contains("".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED))) {
                    buttonSettings.classList.remove("".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED));
                }
                buttonSettings.focus();
            }, bc_data_table_constants_1.BcDataTableConstansts.TIME_OUT);
        }
    };
    BcDataTableHeaderSettingsBehavior.prototype._createSectionElement = function (popOverId) {
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.setAttribute(common_constants_1.BcCommonConstants.ROLE, bc_data_table_constants_1.BcDataTableConstansts.DIALOG);
        sectionElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.WIDTH, bc_data_table_constants_1.BcDataTableConstansts.DIALOG_DEFAULT_WIDTH.toString());
        sectionElement.setAttribute("".concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_ATTR_POSITION), "".concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_ATTR_BOTTOM_LEFT));
        sectionElement.setAttribute("".concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_ATTR_HIDDEN_ARROW), 'false');
        sectionElement.setAttribute("".concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_ATTR_BUTTON_CLOSE), 'false');
        sectionElement.setAttribute("".concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_ATTR_CLOSE_OUTSIDE), 'false');
        sectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS);
        sectionElement.id = popOverId;
        return sectionElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype._createInnerSectionElement = function () {
        var innerSectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        innerSectionElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CONTAINER_CLASS);
        return innerSectionElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype._createHtmlPopOverIcon = function (popOverId) {
        var iconButton = this._createIconButton(bc_data_table_constants_1.BcDataTableConstansts.SETTINGS_TEXT, 'large');
        var configTooltip = this._configTooltip();
        iconButton.setAttribute(common_constants_1.BcCommonConstants.ID, this.tooltipId);
        iconButton.setAttribute(common_constants_1.BcCommonConstants.ARIA_CONTROL, popOverId);
        iconButton.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ARIA_DESCRIBED_BY, popOverId);
        iconButton.setAttribute(common_constants_1.BcCommonConstants.BC_TOOLTIP_TEXT, configTooltip.text);
        iconButton.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATR_TOOLTIP_POSITION, configTooltip.position);
        iconButton.classList.add(bc_data_table_constants_1.BcDataTableConstansts.TARGET_CLASS, bc_data_table_constants_1.BcDataTableConstansts.POPOVER_TARGET_CLASS, bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_CLASS, common_constants_1.BcCommonConstants.BC_TOOLTIP_CLASS);
        iconButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, this._setAccesibilitySettingsButton.bind(this));
        iconButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this._toogleDataTableSettings.bind(this));
        return iconButton;
    };
    BcDataTableHeaderSettingsBehavior.prototype._setAccesibilitySettingsButton = function (event) {
        var _this = this;
        if (event.key === bc_data_table_constants_1.BcDataTableConstansts.KEY_ENTER || event.key === bc_data_table_constants_1.BcDataTableConstansts.KEY_SPACE) {
            setTimeout(function () {
                var popOver = document.getElementById(_this.popOverId);
                var buttonClose = popOver.querySelector(".".concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CONTENT_CLOSE_CLASS, " ").concat(common_constants_1.BcCommonConstants.BUTTON_TAG));
                if (popOver.classList.contains("".concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_ACTIVE_CLASS))) {
                    event.target.classList.add("".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED));
                    buttonClose.focus();
                }
                else if (event.target.classList.contains("".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED))) {
                    event.target.classList.remove("".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED));
                }
            }, bc_data_table_constants_1.BcDataTableConstansts.TIME_OUT);
        }
    };
    BcDataTableHeaderSettingsBehavior.prototype._configTooltip = function () {
        if (!this.bcDataTableConfig.header.settings.tooltip) {
            this.bcDataTableConfig.header.settings.tooltip = {};
        }
        this.tooltipId = this.bcDataTableConfig.header.settings.tooltip.id
            ? this.bcDataTableConfig.header.settings.tooltip.id
            : 'tooltip-' + this._generateRandomIdNumber();
        var text = this.bcDataTableConfig.header.settings.tooltip.text
            ? this.bcDataTableConfig.header.settings.tooltip.text
            : bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_TEXT;
        var position = this.bcDataTableConfig.header.settings.tooltip.position
            ? this.bcDataTableConfig.header.settings.tooltip.position
            : bc_data_table_constants_1.BcDataTableConstansts.TOOLTIP_POSITION;
        return { text: text, position: position };
    };
    BcDataTableHeaderSettingsBehavior.prototype._restartMainPopOver = function () {
        var popOver = document.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS, "#").concat(this.popOverId));
        var headerContainer = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.HEADER_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SECTION_CONTAINER));
        var mainPopOver = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.MAIN_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_MAIN_SECTION_CLASS));
        mainPopOver.remove();
        var newMainPopOver = this._createMainSection();
        headerContainer.after(newMainPopOver);
    };
    BcDataTableHeaderSettingsBehavior.prototype._toogleDataTableSettings = function (event) {
        var iconButton = event.target.parentElement;
        var popOver = document.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS, "#").concat(this.popOverId));
        var popOverIsActive = popOver.classList.contains(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_ACTIVE_CLASS);
        if (!popOverIsActive) {
            iconButton.classList.add(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED);
            this.bcPopOverBehavior.openPopOver();
            this.copyPinnedChecked = this._elementsPinnedCheckedPopOver();
            this._restartMainPopOver();
            var buttonApply = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS, ".").concat(common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS));
            var buttonReset = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_SETTINGS_BUTTON_RESET));
            var verifyPinnedChecked = this._verifyPinnedChecked();
            if (verifyPinnedChecked) {
                buttonApply.disabled = true;
                buttonReset.disabled = true;
            }
            else {
                buttonApply.disabled = false;
                buttonReset.disabled = false;
            }
        }
        else {
            iconButton.classList.remove(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED);
            var verifyPinnedChecked = this._verifyPinnedChecked();
            if (!verifyPinnedChecked) {
                this.bcModalBehavior.openModal();
            }
            else {
                this.bcPopOverBehavior.closePopOver();
            }
        }
    };
    BcDataTableHeaderSettingsBehavior.prototype._createSectionContent = function () {
        var containerDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        containerDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_CONTAINER_CLASS);
        var headerDiv = this._createHeaderSection();
        var mainDiv = this._createMainSection();
        var footerDiv = this._createFooterSection();
        containerDiv.appendChild(headerDiv);
        containerDiv.appendChild(mainDiv);
        containerDiv.appendChild(footerDiv);
        return containerDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype._createHeaderSection = function () {
        var headerDiv = document.createElement(bc_data_table_constants_1.BcDataTableConstansts.HEADER);
        headerDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SECTION_CONTAINER);
        var titleH6 = document.createElement(common_constants_1.BcCommonConstants.H6_TAG);
        titleH6.textContent = bc_data_table_constants_1.BcDataTableConstansts.CONFIGURAR_TABLA_TEXT;
        var descriptionDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        descriptionDiv.textContent = bc_data_table_constants_1.BcDataTableConstansts.DESCRIPTION_TEXT;
        headerDiv.appendChild(titleH6);
        headerDiv.appendChild(descriptionDiv);
        return headerDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype._createMainSection = function () {
        var _this = this;
        var mainDiv = document.createElement(bc_data_table_constants_1.BcDataTableConstansts.MAIN_TAG);
        mainDiv.setAttribute('role', 'group');
        mainDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_MAIN_SECTION_CLASS);
        this.bcDataTableConfig.columnHeaders.data.forEach(function (columHeader, columnHeaderIndex) {
            if (columHeader.dataType !== bc_data_table_constants_1.BcDataTableConstansts.DATA_TYPE_CHECKALL &&
                columHeader.dataType !== bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_DATATYPE_ACTIONS) {
                var rowDiv = _this._createRowSection(columHeader, columnHeaderIndex);
                mainDiv.appendChild(rowDiv);
            }
        });
        return mainDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype._createRowSection = function (columHeader, columnHeaderIndex) {
        var rowDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        rowDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.JUSTIFY_CONTENT_SPACE_BETWEEN_CLASS);
        var nameColumn = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        var nameColumnLabel = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        nameColumnLabel.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_CONTAINER_MAIN_LABEL_CLASS);
        nameColumnLabel.textContent = columHeader.name;
        nameColumn.appendChild(nameColumnLabel);
        var divElementContentPinnedCheked = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElementContentPinnedCheked.classList.add(bc_data_table_constants_1.BcDataTableConstansts.FLEX_CLASS, bc_data_table_constants_1.BcDataTableConstansts.ROW_BORDER_CLASS);
        var divElementContentCheckbox = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElementContentCheckbox.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS__MAIN_SECTION_CHECKBOX);
        divElementContentCheckbox.appendChild(this._createSettingCheckbox(columHeader, columnHeaderIndex));
        var divElementContentPinned = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElementContentPinned.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_MAIN_SECTION_PINNED);
        divElementContentPinned.appendChild(this._addPinnedIcon(columHeader));
        divElementContentPinnedCheked.appendChild(divElementContentPinned);
        divElementContentPinnedCheked.appendChild(divElementContentCheckbox);
        rowDiv.appendChild(nameColumn);
        rowDiv.appendChild(divElementContentPinnedCheked);
        return rowDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype._addPinnedIcon = function (columHeader) {
        var iconButton = this._createIconButton(bc_data_table_constants_1.BcDataTableConstansts.ICON_THUMBTACK);
        if (columHeader.pinned) {
            iconButton.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_PINNED_SELECTED, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED);
        }
        this._listennerIconPinned(iconButton);
        return iconButton;
    };
    BcDataTableHeaderSettingsBehavior.prototype._createSettingCheckbox = function (columHeader, columnHeaderIndex) {
        var checkboxElement = this._getCheckbox();
        var inputCheckbox = checkboxElement.querySelector(common_constants_1.BcCommonConstants.INPUT_CHECKBOX_TAG);
        inputCheckbox.id = 'column-header-settings-' + columnHeaderIndex;
        inputCheckbox.checked = columHeader.visible;
        return checkboxElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype._getCheckbox = function () {
        var _this = this;
        var labelElement = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        labelElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_CONTAINER_CLASS);
        var checkboxElement = document.createElement(common_constants_1.BcCommonConstants.INPUT_TAG);
        checkboxElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ATTRIBUTE_TYPE, bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_TEXT);
        checkboxElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this._validateIconPinned(labelElement, checkboxElement);
            var checkboxList = document.querySelectorAll("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, "#").concat(_this.popOverId, " input[type=\"checkbox\"]"));
            var filterCheckboxList = Array.from(checkboxList).filter(function (checkbox) { return checkbox.checked; });
            if (filterCheckboxList.length >= bc_data_table_constants_1.BcDataTableConstansts.NUMBER_MINIMUM_CHECKBOX_CHECKED) {
                _this._verifyButtonApplyFromCheckbox();
            }
            else {
                checkboxElement.checked = true;
            }
        });
        var spanElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        spanElement.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CHECKBOX_CLASS);
        labelElement.appendChild(checkboxElement);
        labelElement.appendChild(spanElement);
        return labelElement;
    };
    BcDataTableHeaderSettingsBehavior.prototype._validateIconPinned = function (labelElement, checkboxElement) {
        var iconPinned = labelElement.parentElement.previousElementSibling.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG);
        if (iconPinned.classList.contains(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_PINNED_SELECTED)) {
            checkboxElement.checked = true;
        }
    };
    BcDataTableHeaderSettingsBehavior.prototype._verifyButtonApplyFromCheckbox = function () {
        var popOver = document.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS, "#").concat(this.popOverId));
        var buttonApply = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS, ".").concat(common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS));
        var buttonReset = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_SETTINGS_BUTTON_RESET));
        var verifyPinnedChecked = this._verifyPinnedChecked();
        if (verifyPinnedChecked) {
            buttonApply.disabled = true;
            buttonReset.disabled = true;
        }
        else {
            buttonApply.disabled = false;
            buttonReset.disabled = false;
        }
    };
    BcDataTableHeaderSettingsBehavior.prototype._createFooterSection = function () {
        var footerDiv = document.createElement(common_constants_1.BcCommonConstants.FOOTER_TAG);
        var applyButton = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        applyButton.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BUTTON_PRIMARY_CLASS, bc_data_table_constants_1.BcDataTableConstansts.BUTTON_SMALL_CLASS);
        applyButton.textContent = bc_data_table_constants_1.BcDataTableConstansts.BUTTON_APPLY_TEXT;
        this._setEventClickApplyButton(applyButton);
        var divButton = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divButton.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_FOOTER_BUTTON);
        divButton.appendChild(applyButton);
        var divRestart = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divRestart.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_FOOTER_LINK);
        var spanElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        var resetButton = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        resetButton.classList.add(common_constants_1.BcCommonConstants.BTN_GHOST_CLASS, common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS, bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_SETTINGS_BUTTON_RESET);
        spanElement.innerHTML = bc_data_table_constants_1.BcDataTableConstansts.RESETLINK_TEXT;
        resetButton.appendChild(spanElement);
        this._setEventClickResetButton(resetButton);
        footerDiv.appendChild(divButton);
        divRestart.appendChild(resetButton);
        footerDiv.appendChild(divRestart);
        return footerDiv;
    };
    BcDataTableHeaderSettingsBehavior.prototype._setEventClickResetButton = function (button) {
        var _this = this;
        button.addEventListener("".concat(common_constants_1.BcCommonConstants.EVENT_CLICK), function () {
            _this.bcDataTableConfig.columnHeaders.data = _this.copyDataTableConfig.columnHeaders.data;
            _this.onApplyClicked();
            _this._restartMainPopOver();
            var popOver = document.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS, "#").concat(_this.popOverId));
            var buttonApply = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS, ".").concat(common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS));
            var buttonReset = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_SETTINGS_BUTTON_RESET));
            buttonApply.disabled = true;
            buttonReset.disabled = true;
        });
    };
    BcDataTableHeaderSettingsBehavior.prototype.getDataConfigCopy = function (dataCopy) {
        this.copyDataTableConfig = dataCopy;
    };
    BcDataTableHeaderSettingsBehavior.prototype._setEventClickApplyButton = function (button) {
        var _this = this;
        button.addEventListener("".concat(common_constants_1.BcCommonConstants.EVENT_CLICK), function () {
            _this._checkCheckboxSettingsList();
            _this.bcPopOverBehavior.closePopOver();
        });
    };
    BcDataTableHeaderSettingsBehavior.prototype.getPinnedArray = function (paginatedData) {
        var _a;
        var dataCopy = JSON.parse(JSON.stringify(paginatedData));
        var indexPinnedRow = (_a = this.bcDataTableConfig.columnHeaders) === null || _a === void 0 ? void 0 : _a.data.findIndex(function (column) { return column.pinned === true; });
        dataCopy.forEach(function (row) {
            var rowCopy = row[indexPinnedRow + 1];
            row.splice(indexPinnedRow + 1, 1);
            row.splice(1, 0, rowCopy);
        });
        return dataCopy;
    };
    BcDataTableHeaderSettingsBehavior.prototype._checkCheckboxSettingsList = function () {
        var _this = this;
        var checkboxList = document.querySelectorAll("#".concat(this.popOverId, " input[type=\"checkbox\"]"));
        this.bcDataTableConfig.columnHeaders.data.forEach(function (columHeader, columnHeaderIndex) {
            var _a, _b;
            if (columHeader.dataType !== bc_data_table_constants_1.BcDataTableConstansts.DATA_TYPE_CHECKALL ||
                columHeader.dataType !== bc_data_table_constants_1.BcDataTableConstansts.COLUMN_HEADER_DATATYPE_ACTIONS) {
                if (_this.bcDataTableConfig.multicheck) {
                    columHeader.visible = (_a = checkboxList[columnHeaderIndex - 1]) === null || _a === void 0 ? void 0 : _a.checked;
                }
                else {
                    columHeader.visible = (_b = checkboxList[columnHeaderIndex]) === null || _b === void 0 ? void 0 : _b.checked;
                }
            }
        });
        var iconPinned = document.querySelector("#".concat(this.popOverId, " button.").concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_PINNED_SELECTED));
        var pinnedColumn = this.bcDataTableConfig.columnHeaders.data.find(function (column) { return column.name === (iconPinned === null || iconPinned === void 0 ? void 0 : iconPinned.parentElement.parentElement.previousSibling.textContent); });
        this.bcDataTableConfig.columnHeaders.data.map(function (column) { return (column.pinned = false); });
        if (pinnedColumn) {
            pinnedColumn.pinned = true;
        }
        this.onApplyClicked();
        var dataCopy = JSON.parse(JSON.stringify(this.bcDataTableConfig));
        this.getDataConfigCopy(dataCopy);
        this._deleteClassActiveIconButton();
    };
    BcDataTableHeaderSettingsBehavior.prototype._listennerIconPinned = function (icon) {
        var _this = this;
        icon.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this._validateCheckboxChecked(icon);
            var popOver = document.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS, "#").concat(_this.popOverId));
            var buttonApply = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS, ".").concat(common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS));
            var buttonReset = popOver.querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_SETTINGS_BUTTON_RESET));
            var buttonsPinned = popOver.querySelectorAll("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_GHOST_CLASS, ".").concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_MEDIUM_CLASS));
            buttonsPinned.forEach(function (buttonIcon) {
                var _a;
                (_a = buttonIcon.classList) === null || _a === void 0 ? void 0 : _a.remove(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_PINNED_SELECTED, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED);
            });
            icon.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_PINNED_SELECTED, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED);
            var verifyPinnedChecked = _this._verifyPinnedChecked();
            if (verifyPinnedChecked) {
                buttonApply.disabled = true;
                buttonReset.disabled = true;
            }
            else {
                buttonApply.disabled = false;
                buttonReset.disabled = false;
            }
        });
    };
    BcDataTableHeaderSettingsBehavior.prototype._validateCheckboxChecked = function (iconButton) {
        var checkbox = iconButton.parentElement.nextElementSibling.querySelector('input[type="checkbox"]');
        if (!checkbox.checked) {
            checkbox.checked = true;
        }
    };
    BcDataTableHeaderSettingsBehavior.prototype._createIconButton = function (icon, size) {
        if (size === void 0) { size = 'medium'; }
        var iElement = document.createElement(common_constants_1.BcCommonConstants.I_TAG);
        iElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        iElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_HIDDEN, 'true');
        iElement.innerHTML = icon;
        var iconButton = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        iconButton.classList.add(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_GHOST_CLASS, "".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, "-").concat(size));
        iconButton.appendChild(iElement);
        return iconButton;
    };
    BcDataTableHeaderSettingsBehavior.prototype._elementsPinnedCheckedPopOver = function () {
        var popOver = document.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_data_table_constants_1.BcDataTableConstansts.POPOVER_CLASS, "#").concat(this.popOverId));
        var buttonsPinned = popOver.querySelectorAll("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ".").concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG, ".").concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_GHOST_CLASS, ".").concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_MEDIUM_CLASS));
        var buttonsPinnedArray = Array.from(buttonsPinned).map(function (button) {
            return button.classList.contains(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_PINNED_SELECTED);
        });
        var checkBoxChecked = popOver.querySelectorAll('input[type="checkbox"]');
        var checkBoxCheckedArray = Array.from(checkBoxChecked).map(function (checkBox) { return checkBox.checked; });
        return {
            buttonsPinnedArray: buttonsPinnedArray,
            checkBoxCheckedArray: checkBoxCheckedArray,
        };
    };
    BcDataTableHeaderSettingsBehavior.prototype._verifyPinnedChecked = function () {
        var currentPinnedChecked = this._elementsPinnedCheckedPopOver();
        var compareButtonsPinned = this._compareBooleansArrays(this.copyPinnedChecked.buttonsPinnedArray, currentPinnedChecked.buttonsPinnedArray);
        var compareCheckBox = this._compareBooleansArrays(this.copyPinnedChecked.checkBoxCheckedArray, currentPinnedChecked.checkBoxCheckedArray);
        return compareButtonsPinned && compareCheckBox;
    };
    BcDataTableHeaderSettingsBehavior.prototype._compareBooleansArrays = function (array1, array2) {
        for (var index = 0; index < array1.length; index++) {
            if (array1[index] !== array2[index]) {
                return false;
            }
        }
        return true;
    };
    BcDataTableHeaderSettingsBehavior.prototype._listenerApplyButtonModal = function (button) {
        var _this = this;
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.bcModalBehavior.closeModal();
            _this._checkCheckboxSettingsList();
            _this.bcPopOverBehavior.closePopOver();
        });
    };
    BcDataTableHeaderSettingsBehavior.prototype._listenerCancelButtonModal = function (button) {
        var _this = this;
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this._deleteClassActiveIconButton();
            _this.bcModalBehavior.closeModal();
            _this.bcPopOverBehavior.closePopOver();
        });
    };
    BcDataTableHeaderSettingsBehavior.prototype.listenerButtonClosePopOver = function (button) {
        var _this = this;
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            var verifyPinnedChecked = _this._verifyPinnedChecked();
            if (!verifyPinnedChecked) {
                _this.bcModalBehavior.openModal();
            }
            else {
                _this._deleteClassActiveIconButton();
                _this.bcPopOverBehavior.closePopOver();
            }
        });
    };
    BcDataTableHeaderSettingsBehavior.prototype._deleteClassActiveIconButton = function () {
        var headerDatatable = document.getElementById(this.bcDataTableConfig.id);
        var parentHeader = headerDatatable.parentElement;
        var settingsIcon = parentHeader.querySelector(".".concat(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_SETTINGS_ICON_CLASS));
        settingsIcon.classList.remove(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED);
    };
    BcDataTableHeaderSettingsBehavior.prototype._createModal = function () {
        if (!this.bcDataTableConfig.header.settings.modal) {
            this.bcDataTableConfig.header.settings.modal = {};
        }
        if (!this.bcDataTableConfig.header.settings.modal.id) {
            this.bcDataTableConfig.header.settings.modal.id = 'modal-' + this._generateRandomIdNumber();
        }
        this.initModal();
    };
    BcDataTableHeaderSettingsBehavior.prototype.initModal = function () {
        this.bcDataTableHeaderSettingsModal = new bc_data_table_header_settings_modal_1.BcDataTableHeaderSettingsModal(this.bcDataTableConfig);
        var modalElement = this.bcDataTableHeaderSettingsModal.createStructureModal();
        document.body.appendChild(modalElement);
        var buttonsModal = modalElement.querySelectorAll(".".concat(bc_data_table_constants_1.BcDataTableConstansts.MODAL_BUTTON_CONTAINER, " > ").concat(common_constants_1.BcCommonConstants.BUTTON_TAG));
        this._listenerApplyButtonModal(buttonsModal[0]);
        this._listenerCancelButtonModal(buttonsModal[1]);
        this.bcModalBehavior = new bc_modal_behavior_1.BcModalBehavior();
        this.bcModalBehavior.setId(this.bcDataTableConfig.header.settings.modal.id);
        this.bcModalBehavior.setUp();
    };
    return BcDataTableHeaderSettingsBehavior;
}());
exports.BcDataTableHeaderSettingsBehavior = BcDataTableHeaderSettingsBehavior;
